// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `bai-catalog-search-results .divider {
  border-top: 1px solid black;
}

bai-catalog-search-results p.large {
  font-size: 16px;
  font-weight: 700;
}

bai-catalog-search-results p.medium {
  font-size: 14px;
}

bai-catalog-search-results p.small {
  font-size: 12px;
  margin-bottom: 5px;
}

bai-catalog-search-results p.title {
  color: #0076a8;
}

bai-catalog-search-results p.title a.course-title {
  color: #0076a8;
  text-decoration: none;
}

bai-catalog-search-results p.title a:hover {
  text-decoration: underline;
}

bai-catalog-search-results label {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 0;
}

bai-catalog-search-results label.facet-header {
  font-weight: bold;
  margin-bottom: 5px;
}

bai-catalog-search-results a.view-all {
  font-size: 14px;
  font-weight: normal;
  color: #00a1de;
  padding-left: 1em;
  text-decoration: none;
}
bai-catalog-search-results a:hover.view-all {
  text-decoration: underline;
}

bai-catalog-search-results a.clear-all {
  font-size: 14px;
  font-weight: normal;
  color: #00a1de;
  padding-left: 1em;
  text-decoration: none;
  float: right;
  line-height: 1.5;
}

bai-catalog-search-results a:hover.clear-all {
  text-decoration: underline;
}

bai-catalog-search-results .small-menu-down-up {
  padding-left: 0;
  font-size: 10px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/catalog/catalogSearch.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB","sourcesContent":["bai-catalog-search-results .divider {\n  border-top: 1px solid black;\n}\n\nbai-catalog-search-results p.large {\n  font-size: 16px;\n  font-weight: 700;\n}\n\nbai-catalog-search-results p.medium {\n  font-size: 14px;\n}\n\nbai-catalog-search-results p.small {\n  font-size: 12px;\n  margin-bottom: 5px;\n}\n\nbai-catalog-search-results p.title {\n  color: #0076a8;\n}\n\nbai-catalog-search-results p.title a.course-title {\n  color: #0076a8;\n  text-decoration: none;\n}\n\nbai-catalog-search-results p.title a:hover {\n  text-decoration: underline;\n}\n\nbai-catalog-search-results label {\n  font-size: 14px;\n  font-weight: normal;\n  margin-bottom: 0;\n}\n\nbai-catalog-search-results label.facet-header {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\nbai-catalog-search-results a.view-all {\n  font-size: 14px;\n  font-weight: normal;\n  color: #00a1de;\n  padding-left: 1em;\n  text-decoration: none;\n}\nbai-catalog-search-results a:hover.view-all {\n  text-decoration: underline;\n}\n\nbai-catalog-search-results a.clear-all {\n  font-size: 14px;\n  font-weight: normal;\n  color: #00a1de;\n  padding-left: 1em;\n  text-decoration: none;\n  float: right;\n  line-height: 1.5;\n}\n\nbai-catalog-search-results a:hover.clear-all {\n  text-decoration: underline;\n}\n\nbai-catalog-search-results .small-menu-down-up {\n  padding-left: 0;\n  font-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
